import React, { useState, useEffect } from 'react';
import { groupsStatisticsActions } from './actions';
import './StatisticsGroups.css';

const StatisticaInvites = ({ kgId }) => {
  const [infoInvites, setInfoInvites] = useState([]);
  const [loading, setLoading] = useState(false);

  const shNoneInfo = (
    <div className="alert alert-info text-center">
      Не має інформації в обраному періоді
    </div>
  );

  const statusInfo = {
    'invite-sent': 'розглядає',
    'invite-accepted': 'підтверджено'
  };

  const getInfoAboutInvites = async () => {
    setLoading(true);
    try {
      const res = await groupsStatisticsActions.getInvitesByKg(kgId);
      
      if (res.data && res.data.cursor && Array.isArray(res.data.cursor) && res.data.cursor.length > 0) {
        setInfoInvites(res.data.cursor);
      } else {
        setInfoInvites([]);
      }
    } catch (error) {
      console.error('Error fetching invites:', error);
      setInfoInvites([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getInfoAboutInvites();
  }, [kgId]);

  const tableInfo = () => {
    if (!infoInvites || infoInvites.length === 0) {
      return shNoneInfo;
    }

    let count = 0;

    const tableRows = infoInvites.flatMap((itemGr) => {
      const grNumber = itemGr._id.grNumber;

      return itemGr.requests.map((item) => {
        count += 1;

        return (
          <tr key={`${itemGr._id.kgId}-${item._id}-${count}`}>
            <td className="fw-semibold">{count}</td>
            <td className="fw-bold">{grNumber}</td>
            <td>{new Date(item.dateFrom).toLocaleDateString('uk-UK')}</td>
            <td>{new Date(item.dateTo).toLocaleDateString('uk-UK')}</td>
            <td>
              <span className={`badge ${
                item.currentStatus === 'invite-accepted' ? 'bg-success' : 'bg-warning'
              }`}>
                {statusInfo[item.currentStatus] || item.currentStatus}
              </span>
            </td>
            <td>{item.child.firstName}</td>
            <td>{new Date(item.child.birthDate).toLocaleDateString('uk-UK')}</td>
            <td>{item.child.birthCertificate.number}</td>
          </tr>
        );
      });
    });

    return (
      <div className="card mt-4 statistics-groups-container">
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <h5 className="card-title">
                Інформація про запрошення станом на {new Date().toLocaleDateString('uk-UK')}
              </h5>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped table-hover statistics-table statistics-table-striped statistics-table-hover">
              <thead className="statistics-table-primary">
                <tr>
                  <th scope="col">№</th>
                  <th scope="col">Група</th>
                  <th scope="col">Дата запрошення</th>
                  <th scope="col">Термін</th>
                  <th scope="col">Статус</th>
                  <th scope="col">Ім'я</th>
                  <th scope="col">Дата народження</th>
                  <th scope="col">Свідоцтво</th>
                </tr>
              </thead>
              <tbody>
                {tableRows}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container-fluid">
      {loading ? (
        <div className="d-flex justify-content-center align-items-center py-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Завантаження...</span>
          </div>
          <span className="ms-2">Завантаження...</span>
        </div>
      ) : (
        tableInfo()
      )}
    </div>
  );
};

export default StatisticaInvites;